// @flow
import { createSelector } from "reselect"

import set from "common/utils/set"
import type { Action } from "./actions"
import type { Banner } from "../../../../app/scripts/tools/banner.types"

export type BannersConfig = {
  length?: number,
  banners: Array<Banner>,
  showOnMobile: boolean,
}

export type RemoteConfig = {
  bannersConfig: BannersConfig,
  chatModal: {
    text: string,
  },
  delayedChat: {
    showDelayedChat: boolean,
    chatEnabled: boolean,
    titleText: ?string,
    recoverText: ?string,
    alternativeContactText: ?string,
    alternativeContactLinkText: ?string,
    alternativeContactLinkAddress: ?string,
  },
}
// add modules restrictions for banner and chatModal in future
const DEFAULT_STATE: RemoteConfig = {
  bannersConfig: {
    banners: [],
    showOnMobile: false,
  },
  chatModal: {
    text: "",
  },
  delayedChat: {
    showDelayedChat: false,
    chatEnabled: true,
    titleText: null,
    recoverText: null,
    alternativeContactText: null,
    alternativeContactLinkText: null,
    alternativeContactLinkAddress: null,
  },
}

const remoteConfigReducer = (state: RemoteConfig = DEFAULT_STATE, action: Action): RemoteConfig => {
  switch (action.type) {
    case "SET_BANNERS":
      return set("bannersConfig", action.payload, state)

    case "REMOVE_BANNER": {// eslint-disable-line
      const newArray = [...state.bannersConfig.banners]
      newArray.splice(action.payload.index, 1)
      return set(["bannersConfig", "banners"], newArray, state)
    }

    case "SET_CHAT_MODAL":
      return set("chatModal", action.payload, state)

    case "SET_DELAYED_CHAT":
      return set("delayedChat", action.payload, state)

    default:
      return state
  }
}

export default remoteConfigReducer

// Data selectors
// ===

const getRemoteConfig = state => state.remoteConfig

export const bannersConfigSelector: $FlowFixMe = createSelector(
  getRemoteConfig,
  remoteConfig => remoteConfig.bannersConfig,
)
export const chatModalTextSelector: $FlowFixMe = createSelector(
  getRemoteConfig,
  remoteConfig => remoteConfig.chatModal.text,
)
export const delayedChatSelector: $FlowFixMe = createSelector(
  getRemoteConfig,
  remoteConfig => remoteConfig.delayedChat,
)
